import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { callbackDomain } from '@portal/app/dashboard/integrations/shared/constants';
import { WindowService } from '@portal/app/shared/services/window.service';

@Component({
  selector: 'portal-amazon-oauth-login',
  templateUrl: './amazon-oauth-login.component.html',
  styles: []
})
export class AmazonOAuthLoginComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private readonly windowService: WindowService
  ) {}

  ngOnInit(): void {
    const vendorSlug = this.route.snapshot.data['vendorSlug'] as
      | string
      | undefined;

    if (!vendorSlug) {
      console.error('Missing vendorSlug in route data for Amazon OAuth login.');
      return;
    }

    this.route.queryParams.subscribe((params) => {
      const amazonCallbackUri = params['amazon_callback_uri'];
      const amazonState = params['amazon_state'];
      const sellingPartnerId = params['selling_partner_id'];

      if (!amazonCallbackUri || !amazonState || !sellingPartnerId) {
        console.error('Missing required Amazon login parameters.');
        return;
      }

      const appState = localStorage.getItem('appState');

      const redirectURL = new URL(amazonCallbackUri);
      redirectURL.searchParams.append('amazon_state', amazonState);
      redirectURL.searchParams.append('state', appState || '');
      redirectURL.searchParams.append(
        'redirect_uri',
        `${callbackDomain()}oauth/callback/${vendorSlug}`
      );

      this.windowService.navigateToHref(redirectURL.toString());
    });
  }
}
